import React from "react";

/**
 * Consent block used on all public forms (Missing Stickers, RSVP, Contact).
 * Backend expects payload.consent = { required_agreement, marketing_email, marketing_sms }.
 * value: { required_agreement, marketing_email, marketing_sms }
 * onChange: (next) => void
 * settings: public settings object (for consent wording, versioned)
 */
export default function ConsentBlock({ value, onChange, settings, prefix = "consent" }) {
  const s = settings || {};
  const required = s.consent_text_required ||
    "I agree to be contacted regarding this request so Gil Maakaroun can review availability, prepare my order, and communicate with me about this request.";
  const email = s.consent_text_marketing_email ||
    "I would like to receive updates about future products, events, and collector news by email.";
  const sms = s.consent_text_marketing_sms ||
    "I would like to receive updates about future products, events, and collector news by SMS or WhatsApp.";

  const set = (k) => (e) => onChange({ ...value, [k]: e.target.checked });

  return (
    <div className="rounded-2xl border-2 border-[var(--ink)] bg-[var(--panini-yellow-soft)] p-5">
      <div className="kicker kicker-red mb-3 text-[11px]">Consent & Communication</div>

      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={!!value?.required_agreement}
          onChange={set("required_agreement")}
          data-testid={`${prefix}-required`}
          className="mt-1 w-4 h-4 accent-[var(--panini-red)]"
        />
        <span className="text-sm text-[var(--ink)] leading-relaxed">
          <span className="font-bold text-[var(--panini-red)]">Required · </span>
          {required}
        </span>
      </label>

      <label className="flex items-start gap-3 mt-4 cursor-pointer">
        <input
          type="checkbox"
          checked={!!value?.marketing_email}
          onChange={set("marketing_email")}
          data-testid={`${prefix}-marketing-email`}
          className="mt-1 w-4 h-4 accent-[var(--field-green)]"
        />
        <span className="text-sm text-[var(--ink)] leading-relaxed">
          <span className="font-bold text-[var(--field-green)]">Optional · </span>
          {email}
        </span>
      </label>

      <label className="flex items-start gap-3 mt-4 cursor-pointer">
        <input
          type="checkbox"
          checked={!!value?.marketing_sms}
          onChange={set("marketing_sms")}
          data-testid={`${prefix}-marketing-sms`}
          className="mt-1 w-4 h-4 accent-[var(--field-green)]"
        />
        <span className="text-sm text-[var(--ink)] leading-relaxed">
          <span className="font-bold text-[var(--field-green)]">Optional · </span>
          {sms}
        </span>
      </label>
    </div>
  );
}
